module.exports = __webpack_public_path__ + "static/kartchen-mobilitat2-49f1f8968c558eb99e3e182effd4678a.png";